import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, LockKeyhole, LogIn, Mail } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { formatAuthError } from "@/lib/authErrors";
import { useSeo } from "@/lib/seo";

export default function Login() {
    useSeo({ title: "Accedi a VendiDirect", description: "Gestisci i tuoi immobili con l'IA", canonical: "/login", noindex: true });
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const [form, setForm] = useState({ email: "", password: "" });
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");

    const handleLogin = async (event) => {
        event.preventDefault(); setBusy(true); setError("");
        try {
            const { data } = await api.post("/auth/login", form);
            setUser(data.user);
            navigate(data.user?.is_admin ? "/admin" : data.user?.is_collaborator ? "/analytics-pro" : "/dashboard");
        } catch (requestError) {
            setError(formatAuthError(requestError?.response?.data?.detail, "Accesso non riuscito"));
        } finally { setBusy(false); }
    };

    return (
        <main data-testid="login-page" className="login-luxury-page">
            <div className="login-luxury-panel">
                <div className="text-center">
                    <div className="login-luxury-logo" data-testid="login-logo-badge">
                        <img src="/vendidirect_logo_nebula_hd.jpg" alt="Logo 3D Luxury Gold VendiDirect" draggable="false" />
                    </div>
                    <h1 data-testid="login-title" className="login-luxury-title">Accedi a VendiDirect</h1>
                    <p data-testid="login-subtitle" className="login-luxury-subtitle">Gestisci i tuoi immobili con l&apos;IA</p>
                </div>

                <form data-testid="local-login-form" onSubmit={handleLogin} className="login-credentials-form">
                    <label className="login-field"><span><Mail size={14} /> Email</span><input data-testid="login-email-input" type="email" autoComplete="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="login-input" placeholder="nome@email.it" /></label>
                    <label className="login-field"><span><LockKeyhole size={14} /> Password</span><input data-testid="login-password-input" type="password" autoComplete="current-password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="login-input" placeholder="La tua password" /></label>
                    <Link data-testid="forgot-password-link" to="/password-dimenticata" className="login-forgot-link">Password dimenticata?</Link>
                    {error && <div data-testid="login-error" className="login-alert login-alert-error">{error}</div>}
                    <button data-testid="login-submit-button" type="submit" disabled={busy} className="login-submit-button">{busy ? <Loader2 className="animate-spin" size={17} /> : <LogIn size={17} />} Accedi</button>
                </form>

                <p className="login-luxury-legal">
                    Accedendo accetti i nostri <Link data-testid="login-terms-link" to="/termini">Termini</Link> e l&apos;<Link data-testid="login-privacy-link" to="/privacy">Informativa privacy</Link>.
                </p>
            </div>
        </main>
    );
}
